"use client"
import DtvFlash from "@/video-lab/dtv-flash"

export function FlashClient(props) {
  return <DtvFlash {...props} />
}

export default FlashClient;
